import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ChevronRight, Pencil, Handshake } from "lucide-react";
import Cookies from "js-cookie";
import AgentImage from "../../pages/index/img/postperty_agent.jpg";

const OPTIONS = [
  {
    to: "/help/postperty",
    img: AgentImage,
    Icon: Handshake,
    title: "ให้ Postperty ช่วยขาย",
    sub: "ทีมงานมืออาชีพดูแลทุกขั้นตอน",
    accent: "from-blue-500 to-postperty",
  },
  {
    to: "/create/select",
    img: "https://images.unsplash.com/photo-1582407947304-fd86f028f716?fm=jpg&q=60&w=3000",
    Icon: Pencil,
    title: "ลงประกาศขายเอง",
    sub: "สร้างประกาศได้ในไม่กี่นาที",
    accent: "from-orange-400 to-rose-500",
  },
];

export default function SelectPostAssets() {
  const navigate = useNavigate();

  useEffect(() => {
    if (!Cookies.get("jwt")) navigate("/login", { replace: true });
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-xl mx-auto px-4 pt-10 pb-24">

        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.35 }}
          className="mb-6"
        >
          <p className="text-sm text-gray-400 uppercase tracking-widest mb-1">Postperty</p>
          <h1 className="text-2xl font-bold text-gray-900">ลงประกาศอสังหาฯ</h1>
          <p className="text-base text-gray-400 mt-1">เลือกวิธีที่เหมาะกับคุณ</p>
        </motion.div>

        <div className="flex flex-col gap-4">
          {OPTIONS.map(({ to, img, Icon, title, sub, accent }, i) => (
            <motion.div
              key={to}
              initial={{ opacity: 0, y: 14 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.35, delay: 0.08 * i }}
            >
              <Link to={to}>
                <div className="relative bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden group hover:shadow-md hover:border-gray-200 transition-all">
                  {/* background image */}
                  <div className="relative h-52 overflow-hidden">
                    <img
                      src={img}
                      alt={title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                  </div>

                  {/* content overlay */}
                  <div className="absolute bottom-0 left-0 right-0 p-4 flex items-end justify-between">
                    <div className="flex items-center gap-3">
                      <div className={`w-11 h-11 rounded-xl bg-gradient-to-br ${accent} flex items-center justify-center shadow-lg`}>
                        <Icon size={22} className="text-white" />
                      </div>
                      <div>
                        <p className="text-white font-bold text-base leading-tight">{title}</p>
                        <p className="text-white/70 text-sm mt-0.5">{sub}</p>
                      </div>
                    </div>
                    <div className="w-8 h-8 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center">
                      <ChevronRight size={16} className="text-white" />
                    </div>
                  </div>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}
